import { useCallback } from 'react';
import { useApiError, useAppData } from 'src/providers';
import { DateRange } from '@material-ui/pickers';
import { DetailsModel } from '../MasteIBCommissionModel';
import { getMasterIBCommissionReportDetail } from '../MasterIbCommissionService';

const useGetReportDetails = ({ dateRange, setSummaryData, setIsLoading }: { dateRange: DateRange<Date>; setIsLoading: (data: boolean) => void; setSummaryData: (data: DetailsModel[]) => void }) => {
  const { addError } = useApiError();
  const { userData } = useAppData();

  return useCallback(
    async (partnershipCode: string) => {
      const loginData = JSON.parse(userData);
      setIsLoading(true);

      if (dateRange && dateRange[0] && dateRange[1]) {
        try {
          const response = await getMasterIBCommissionReportDetail({
            clientMembershipFID: 0,
            partnershipCode,
            PartnerId: loginData.partnerID,
            Month: dateRange[0].getMonth() + 1,
            Year: dateRange[0].getFullYear(),
            Day: dateRange[0].getDate(),
            EndMonth: dateRange[1].getMonth() + 1,
            EndYear: dateRange[1].getFullYear(),
            EndDay: dateRange[1].getDate(),
            ConvertToCurrency: 'USD',
            RequesterAccountGuid: loginData.defaultAccount,
          });

          setSummaryData([response.data]);
        } catch (error) {
          addError(JSON.stringify(error.response));
        } finally {
          setIsLoading(false);
        }
      }
    },
    [userData, dateRange, setIsLoading, setSummaryData, addError],
  );
};

export default useGetReportDetails;
